<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body="{height}" v-if="!!storeAggregate && !!storeAggregate.rootData">
        <v-sheet
            v-if="!!currentItem"
            class="px-3 py-3"
        >
          <v-tabs>
            <v-tab>{{ $t('common') }}</v-tab>
            <v-tab-item>
              <v-row>
                <v-col cols="4">
                  <v-card :height="height - 90" class="overflow-y-auto pr-5">
                    <v-row class="mt-1">
                      <v-col cols="3">
                        <CommonFieldString
                            v-model="storeAggregate.rootData[currentItem.component_uid].article_display"
                            :label="$t('article_display')"
                            class="mt-3"
                            readonly=""
                            hide-details
                            :prepend-icon="manualIcon"
                            @click:prepend="onComponentClick(currentItem)"
                        ></CommonFieldString>
                      </v-col>
                      <v-col cols="9">
                        <CommonFieldString
                            v-model="storeAggregate.rootData[currentItem.component_uid].alias"
                            :label="$t('alias')"
                            class="mt-3"
                            readonly=""
                            hide-details
                        >
                        </CommonFieldString>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="6">
                        <v-icon>{{ manualIcon }}</v-icon>
                        <v-chip
                            v-if="!!storeDetail.common && !!storeDetail.common.data && !!storeDetail.common.data.supply_type_dict"
                            :color="currentItem.supply_type_dict.color"
                        >
                          {{ currentItem.supply_type_dict.text }}
                        </v-chip>
                      </v-col>
                      <v-col cols="6">
                        <v-chip
                            v-if="!!storeDetail.common && !!storeDetail.common.data && !!storeDetail.common.data.status_dict"
                            :color="currentItem.status_dict.color"
                        >
                          {{ currentItem.status_dict.text }}
                        </v-chip>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <v-autocomplete
                            v-if="!!storeDetail.common && !!storeDetail.common.data && !!storeDetail.common.data.usage_restriction_list"
                            v-model="storeAggregate.rootData[currentItem.material_delivery_uid].provider_uid"
                            :items="storeDetail.common.data.usage_restriction_list"
                            :label="$t('provider')"
                            outlined
                            dense
                            class="mt-2 mr-5"
                            readonly
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <v-autocomplete
                            v-if="!!storeDetail.common && !!storeDetail.common.data && !!storeDetail.common.data.usage_restriction_list"
                            v-model="currentItem.material_owner_uid"
                            :items="storeDetail.common.data.usage_restriction_list"
                            :label="$t('material_owner')"
                            outlined
                            clearable
                            dense
                            class="mt-2 mr-5"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="8">
                        <v-autocomplete
                            v-if="!!storeDetail.common && !!storeDetail.common.data && !!storeDetail.common.data.usage_restriction_list"
                            v-model="currentItem.usage_restriction_uid"
                            :items="storeDetail.common.data.usage_restriction_list"
                            :label="$t('usage_restriction')"
                            outlined
                            clearable
                            dense
                            class="mt-2 mr-5"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                        <CommonFieldString
                            :value="(!!storeAggregate.rootData && !!currentItem && !!currentItem.part_number_uid && !!storeAggregate.rootData[currentItem.part_number_uid]) ? storeAggregate.rootData[currentItem.part_number_uid].part_number : null"
                            label="P/N"
                            class="mt-3"
                            readonly=""
                            hide-details
                            prepend-icon="mdi-book-sync-outline"
                            @click:prepend="onBindPartNumber(currentItem)"
                        ></CommonFieldString>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12">
                        <CommonFieldString
                            v-model="storeAggregate.rootData[currentItem.material_delivery_uid].delivery_number"
                            :label="$t('delivery_number')"
                            class="mt-3"
                            readonly=""
                            hide-details
                        ></CommonFieldString>
                      </v-col>
                      <!--                    <v-col cols="7">-->
                      <!--                      <CommonFieldString-->
                      <!--                          v-if="!!storeAggregate.rootData[currentItem.part_number_uid]"-->
                      <!--                          v-model="storeAggregate.rootData[currentItem.part_number_uid].part_number"-->
                      <!--                          :label="$t('part_number')"-->
                      <!--                          class="mt-3"-->
                      <!--                          readonly=""-->
                      <!--                          hide-details-->
                      <!--                      ></CommonFieldString>-->
                      <!--                    </v-col>-->
                    </v-row>
                    <v-row dense>
                      <v-col cols="6">
                        <CommonFieldNumber
                            v-model="currentItem.initial_qty"
                            :label="$t('initial_qty')"
                            class="mt-3"
                            readonly=""
                            hide-details
                        ></CommonFieldNumber>
                      </v-col>
                      <v-col cols="6">
                        <CommonFieldNumber
                            v-model="currentItem.current_qty"
                            :label="$t('current_qty')"
                            class="mt-3"
                            readonly=""
                            hide-details
                            :prepend-icon="manualIcon"
                        ></CommonFieldNumber>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="6">
                        <CommonFieldNumber
                            v-model="currentItem.reservation_quantity"
                            :label="$t('reservation_quantity')"
                            class="mt-3"
                            readonly=""
                            hide-details
                        ></CommonFieldNumber>
                      </v-col>
                      <v-col cols="6">
                        <CommonFieldNumber
                            v-model="currentItem.not_used_qty"
                            :label="$t('not_used_qty')"
                            class="mt-3"
                            readonly=""
                            hide-details
                        ></CommonFieldNumber>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <CommonFieldText
                            v-if="!!currentItem.component_uid"
                            v-model="storeAggregate.rootData[currentItem.component_uid].description"
                            :label="$t('description')"
                            class="mt-3"
                            :readonly="true"
                            rows="4"
                            hide-details
                        ></CommonFieldText>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="10">
                        <CommonFieldString
                            v-model="location"
                            :label="$t('location')"
                            class="mt-3"
                            readonly=""
                            hide-details
                            :prepend-icon="manualIcon"
                        >
                        </CommonFieldString>
                      </v-col>
                      <v-col cols="2">
                        <CommonFieldString
                            v-model="location_temperature"
                            label="Temperature"
                            class="mt-3"
                            readonly=""
                            hide-details
                        >
                        </CommonFieldString>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="3">
                        <MaterialLifecycleSelect :value="currentItem.lifecycle" readonly
                                                 label="Material status"
                                                 outlined></MaterialLifecycleSelect>
                      </v-col>
                      <v-col cols="3">
                        <MaterialLifecycleSelect :value="currentItem.pre_lifecycle" readonly
                                                 label="Material status (pre)"
                                                 outlined></MaterialLifecycleSelect>
                      </v-col>
                      <v-col cols="3">
                        <MslLifecycleSelect :value="currentItem.msl_lifecycle" readonly outlined></MslLifecycleSelect>
                      </v-col>
                      <v-col cols="3" >
                        <CommonFieldString
                            v-model="currentItem.msl_timer_str"
                            label="MSL Timer"
                            readonly=""
                            hide-details
                        >
                        </CommonFieldString>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="8">
                  <MaterialReservationTable
                      title="MaterialReservation"
                      :headers="headersMaterialReservation"
                      :height="height - 220"
                      dtoListQuery="MaterialReservationListQueryDTO"
                      :store-name="storeMaterialReservationTableName"
                  >
                  </MaterialReservationTable>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab>{{ $t('detail') }}</v-tab>
            <v-tab-item>
              <v-card>
                <v-simple-table dense :height="height - 100">
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-left">{{ $t('parameter') }}</th>
                      <th class="text-left">{{ $t('value') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="[key, value] of Object.entries(currentItem.data)"
                        :key="key">
                      <td>{{ key }}</td>
                      <td>{{ value }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-tab-item>
            <v-tab>Events</v-tab>
            <v-tab-item>
              <MaterialEventTable
                  :title="$t('material_event')"
                  :top-height="storeDetail.modalDialog === false ? 120 : 210"
                  dtoListQuery="MaterialEventListQueryDTO"
                  :store-name="storeMaterialEventTableName"
              >
                <template v-slot:footer.prepend>{{ '' }}</template>
              </MaterialEventTable>
            </v-tab-item>
          </v-tabs>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import {useTableStore} from "@/components/Common/CommonTable"
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldText from "@/components/Base/BaseFieldText";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";
import BaseFieldSelect from "@/components/Base/BaseFieldSelect";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CommonFieldNumber from "@/components/Common/CommonFieldNumber";
import CommonFieldText from "@/components/Common/CommonFieldText";
import MaterialReservationTable from "@/components/CoreMaterial/MaterialReservation/MaterialReservationTable.vue";
import MaterialLifecycleSelect from "@/components/CoreMaterial/Material/MaterialLifecycleSelect.vue";
import MslLifecycleSelect from "@/components/CoreMaterial/Material/MslLifecycleSelect.vue";

export default {
  name: "MaterialDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'MaterialDetail'},
    dtoDetailQuery: {default: 'MaterialDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'MaterialSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'MaterialValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'MaterialBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'MaterialTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    MslLifecycleSelect,
    MaterialLifecycleSelect,
    BaseFieldNumber,
    BaseFieldText,
    BaseFieldString,
    CommonDetail,
    BaseFieldSelect,
    'MaterialEventTable': () => import("@/components/CoreMaterial/MaterialEvent/MaterialEventTable"),
    CommonFieldString,
    CommonFieldNumber,
    CommonFieldText,
    MaterialReservationTable,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
    storeUidItem() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
    location() {
      if (!!this.currentItem &&
          !!this.storeAggregate.rootData[this.currentItem.location_uid])
        return this.storeAggregate.rootData[this.currentItem.location_uid].fullname
      return null
    },
    location_temperature() {
      if (!!this.currentItem &&
          !!this.storeAggregate.rootData[this.currentItem.location_uid])
        return this.storeAggregate.rootData[this.currentItem.location_uid].temperature
      return null
    },
  },

  watch: {
    storeUidItem: {
      handler(newValue, oldValue) {
        // console.log('watch ComponentDetail uidItem', newValue, oldValue)
        this.storeMaterialEventTable.filters = this.storeMaterialEventTable.filters.filter(x => x.param_compare !== 'material__uid')
        this.storeMaterialEventTable.filters.push({param_compare: 'material__uid', value: this.storeDetail.uidItem})
        this.storeMaterialReservationTable.filters = this.storeMaterialReservationTable.filters.filter(x => x.param_compare !== 'material__uid')
        this.storeMaterialReservationTable.filters.push({
          param_compare: 'material__uid',
          value: this.storeDetail.uidItem
        })
      }
    },
  },

  methods: {
    onComponentClick(item) {
      if (!!item && !!item.component_uid) {
        const routeData = this.$router.resolve({name: 'ComponentDetail', params: {uidItem: item.component_uid}});
        console.log('onComponentClick', routeData)
        window.open(routeData.href, '_blank');
      }
    },
    onBindPartNumber(item) {
      this.storeDetail.onAction({actionName: 'bind_part_number', actionUid: item.uid})
    },
  }
  ,

  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()

    this.storeMaterialEventTable = useTableStore(this.storeMaterialEventTableName)()
    this.storeMaterialReservationTable = useTableStore(this.storeMaterialReservationTableName)()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      storeSelectMaterialEventComponent: null,
      storeMaterialEventTable: null,
      storeMaterialReservationTable: null,

      storeMaterialEventTableName: uuidv4(),
      storeMaterialReservationTableName: uuidv4(),
      manualIcon: "mdi-square-edit-outline",

      headersMaterialReservation: [
        {text: 'BatchRun', value: 'batchrun_component__batch_run__name', sortable: true, true: true, divider: true},
        {text: 'Reservation quantity', value: 'quantity', sortable: true, true: true, divider: true},
        {text: 'Current QTY', value: 'material__current_qty', sortable: true, true: true, divider: true},
        {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
        {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      ],
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreMaterial/locales.json">
</i18n>